import { baseApi } from '@/shared/api'
import type { SettlementList, SettlementsQuery } from '../model/types'

export const settlementApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /** Документы взаиморасчётов клиента за период; итоги периода — в `summary`. */
    getSettlements: build.query<SettlementList, SettlementsQuery>({
      query: (params) => ({ url: '/settlements', params }),
      providesTags: [{ type: 'Payment', id: 'SETTLEMENTS' }],
    }),
  }),
})

export const { useGetSettlementsQuery } = settlementApi
